(function(window, document, $) {
  'use strict';

  let marker;
  let map;
  Dropzone.autoDiscover = false;

  function showMessageFeedback({ type, message }) {
    const html = `
      <div class="message-feedback__content">
        <span class="message-feedback__close"><i class="icon-close"></i></span>
        <h3 class="message-feedback__title">${type === 'success' ? 'Sucesso!' : 'Erro!'}</h3>
        <p>${message}</p>
      </div>
    `;

    $('.message-feedback').html(html);

    setTimeout(function() {
      $('.message-feedback').addClass('is-active ' + type);
    }, 200);
  }

  function changeLoaderVisibility(visible) {
    if (visible) {
      $('body').addClass('show-loader');
    } else {
      $('body').removeClass('show-loader');
    }
  }

  function ajaxContentWrapper({ e = {}, url, method = 'GET', dataType = null, formData = null, callbackSuccess = (data) => { console.log(data)}, callbackError = (data) => { console.log(data) }, timeout = 0 }) {
    $.ajax({
      url,
      method,
      dataType,
      data: formData,
      beforeSend: function() {
        changeLoaderVisibility(true);
      },
      success: function(data) {
        callbackSuccess(data);
      },
      error: function(data) {
        callbackError(data);
      },
      complete: function() {
        changeLoaderVisibility(false);
      }
    });
  }

  $(document).ready(() => {
    const homeSlideshow = $('.home-slideshow');

    homeSlideshow.on('init', function(slick) {
      $('.home-slideshow .slick-slide[data-slick-index="0"]').addClass('animate');
    });

    homeSlideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.home-slideshow .slick-slide').removeClass('animate');
    });

    homeSlideshow.on('afterChange', function(event, slick, currentSlide, nextSlide){
      $('.home-slideshow .slick-slide').removeClass('animate');
      $('.home-slideshow .slick-slide[data-slick-index="' + currentSlide + '"]').addClass('animate');
    });

    homeSlideshow.slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 1500,
      slidesToShow: 1,
    });

    $('.service-selector input').on('change', function() {
      const isChecked = $(this).prop('checked');
      const type = isChecked ? 'comunicacao-visual' : 'grafica-rapida';
      const isQuickQuote = $(this).closest('.quick-quote').length > 0;
      const isSubmenu = $(this).closest('.submenu').length > 0;

      $(this).closest('.service-selector').toggleClass('is-checked');

      if (isSubmenu) {
        $('.submenu').toggleClass('is-checked');
      }

      if (!isQuickQuote && !isSubmenu) {
        $('.services-menu').toggleClass('is-checked');

        $('.services-menu__slider').slick('slickUnfilter');
        $('.services-menu__slider').slick('slickFilter', function(index, el) {
          const filteredItem = $(el).find(`.services-menu__item[data-type="${type}"]`);

          return filteredItem.length > 0;
        });
      }

      if (isQuickQuote) {
        $('.quick-quote__service').removeClass('is-active');
        $(`.quick-quote__service[data-category="${type}"]`).addClass('is-active');
      }
    });

    $('.has-submenu > a').click(function(e) {
      e.preventDefault();

      if ($(window).width() > 1010) {
        $('.services-menu').toggleClass('is-active');
        $('.services-menu__slider').slick('slickUnfilter');
        $('.services-menu__slider').slick('slickFilter', function(index, el) {
          const filteredItem = $(el).find(`.services-menu__item[data-type="grafica-rapida"]`);

          return filteredItem.length > 0;
        });
      } else {
        $('.submenu').parent().toggleClass('is-active');
      }
    });

    $('.services-menu__slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 1500,
      slidesToShow: 8,
      variableWidth: true,
    });

    $('.services-slider').slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 1500,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          }
        }
      ]
    });

    $('.js-filter-services a').click(function(e) {
      e.preventDefault();
      const filter = $(this).data('filter');
      $('.services .services-filter__item').removeClass('is-current');
      $(this).addClass('is-current');

      if (filter === 'all') {
        $('.services-slider').slick('slickUnfilter');
      } else {
        $('.services-slider').slick('slickUnfilter');
        $('.services-slider').slick('slickFilter', function(index, el) {
          const filteredItem = $(el).find(`.card-service[data-category="${filter}"]`);

          return filteredItem.length > 0;
        });
      }
    });

    $('.packages__slider').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 1500,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            dots: true,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            dots: true,
            variableWidth: true,
          }
        },
      ]
    });

    $('.about-equipment__slider').slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 1500,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            arrows: false,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows: false,
            variableWidth: true,
          }
        },
      ]
    });

    $('.service__gallery-active').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.service__gallery-nav'
    });

    $('.service__gallery-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.service__gallery-active',
      dots: false,
      centerMode: false,
      focusOnSelect: true
    });

    $('.scroll-up').click(function(e) {
      e.preventDefault();

      $('html, body').stop().animate({
        scrollTop: 0
      }, 2000)
    });

    $('.open-quick-quote').click(function() {
      $('.quick-quote').addClass('is-active');
      $('.quick-quote__step').first().fadeIn();
    });

    $('.quick-quote__close').click(function() {
      $('.quick-quote').removeClass('is-active');
      $('.quick-quote__step').fadeOut();
    });

    $('.quick-quote__service').click(function() {
      $('.quick-quote__service').removeClass('is-current');
      $(this).addClass('is-current');

      $('.js-quick-quote-continue').prop('disabled', false);
    });

    $('.js-quick-quote-continue').click(function() {
      const serviceType = $('.quick-quote__service.is-current').length;
      if (serviceType) {
        const url = $('.quick-quote__service.is-current').find('a').attr('href');

        ajaxContentWrapper({
          url,
          callbackSuccess: (data) => {
            const serviceTitle = $(data).find('.service__title').html();
            const serviceForm = $(data).find('.service__quote');
            $('.quick-quote__step[data-step="2"] .quick-quote__header p').html(serviceTitle);
            $('.quick-quote__step[data-step="2"] .quick-quote__step-content').html(serviceForm);

            setTimeout(function() {
              $('.quick-quote__step').first().fadeOut(function() {
                $('.quick-quote__step[data-step="2"]').fadeIn();
              });
            }, 200);
          }
        })
      }
    });

    $('.quick-quote__back').click(function() {
      $('.quick-quote__step').eq(1).fadeOut(function() {
        $('.quick-quote__step').first().fadeIn();
      });
    });

    $('body').on('click', '.input-qty__increase', function() {
      const inputTarget = $(this).parent().find('input');
      const inputVal = parseInt(inputTarget.val());

      if (inputVal > 0 && inputVal <= 100000) {
        inputTarget.val(inputVal + 50);
      } else {
        inputTarget.val(50);
      }
    });

    $('body').on('click', '.input-qty__decrease', function(e) {
      const inputTarget = $(this).parent().find('input');
      const inputVal = parseInt(inputTarget.val());

      if (inputVal > 50 && inputVal <= 100000) {
        inputTarget.val(inputVal - 50);
      } else {
        e.stopImmediatePropagation();
        inputTarget.val(50);
      }
    });

    if ($('#imageUpload').length) {

      let myDropzone = new Dropzone('div#imageUpload', {
        addRemoveLinks: true,
        autoProcessQueue: false,
        uploadMultiple: true,
        parallelUploads: 100,
        maxFiles: 5,
        createImageThumbnails: false,
        maxFilesize: 10,
        paramName: 'file',
        clickable: true,
        // acceptedFiles: '.pdf',
        dictFileTooBig: 'O arquivo deve ter no máximo {{maxFilesize}}MB',
        dictDefaultMessage: '<i class="icon-attach"></i>Clique aqui ou arraste os arquivos',
        url: $('#imageUploadForm').attr('action'),
        init: function () {
    
            var myDropzone = this;
            var $form = $('#imageUploadForm');
            // Update selector to match your button
            $('#uploaderBtn').click(function (e) {
              e.preventDefault();
              myDropzone.processQueue();
            });
    
            this.on('sending', function (file, xhr, formData) {
                // Append all form inputs to the formData Dropzone will POST
                changeLoaderVisibility(true);
                var data = $form.serializeArray();
                $.each(data, function (key, el) {
                    formData.append(el.name, el.value);
                });
                console.log(formData);
    
            });
        },
        error: function (file, response){
            if ($.type(response) === "string") {
              var message = response; //dropzone sends it's own error messages in string
            } else {
              var message = response.message;
            }
            file.previewElement.classList.add("dz-error");
            var _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
            var _results = [];
            for (var _i = 0, _len = _ref.length; _i < _len; _i++) {
                var node = _ref[_i];
                _results.push(node.textContent = message);
            }
            changeLoaderVisibility(false);
            return _results;
        },
        successmultiple: function (file, response) {
            // console.log(file, response);
            // $modal.modal("show");

            showMessageFeedback({
              type: response.success ? 'success' : 'error',
              message: response.data
            });

            if (response.success) {
              $('#imageUploadForm')[0].reset();
              this.removeAllFiles(true);
            }
            changeLoaderVisibility(false);
        },
        completemultiple: function (file, response) {
            // console.log(file, response, "completemultiple");
            //$modal.modal("show");
        },
        reset: function () {
            // console.log("resetFiles");
            this.removeAllFiles(true);
            changeLoaderVisibility(false);
        }
    });
    }

    $('.menu-trigger').click(function() {
      $('.header').toggleClass('is-opened');
      $('.cta-help').toggleClass('is-active');
    });

    if ($('#map').length) {
      const coordinates = $('#map').data('coordinates');
      const [ lat, lon ] = coordinates.split(',');

      map = L.map('map', {
        center: [lat, lon],
        zoom: 16,
        // zoomControl: false,
        scrollWheelZoom: false,
      });

      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
        attribution: '',
        maxZoom: 16
      }).addTo(map);

      let markerIcon = L.icon({
        iconUrl: themeUrl + '/public/images/marker.png',
        iconSize: [182, 182],
        iconAnchor: [90, 90]
      });

      marker = L.marker([lat, lon], { icon: markerIcon })
        .addTo(map);
    }

    $('.message-feedback').on('click', function(e){
      const target = $(e.target);

      if(target.hasClass('is-active') || target.is('.icon-close')) {
        $('.message-feedback').removeClass('is-active success error');

        setTimeout(() => {
          $('.message-feedback').empty();
        }, 1500)
      }
    });

    $('.newsletter__form, .contact__form').submit(function(e) {
      e.preventDefault();
      const form = $(this);
      const url = form.attr('action');
      const formData = form.serialize();

      ajaxContentWrapper({
        url,
        formData,
        method: 'POST',
        callbackSuccess: (data) => {
          showMessageFeedback({
            type: data.success ? 'success' : 'error',
            message: data.data
          });

          if (data.success) {
            form[0].reset();
          }
        },
        callbackError: (error) => {
          showMessageFeedback({
            type: 'error',
            message: data.data
          })
        }
      })
    });

    $('.quick-quote, .service').on('submit', '.service__quote', function(e) {
      e.preventDefault();
      const form = $(this);
      const url = form.attr('action');
      const formData = form.serialize();

      ajaxContentWrapper({
        url,
        formData,
        method: 'POST',
        callbackSuccess: (data) => {
          console.log(data);
          showMessageFeedback({
            type: data.success ? 'success' : 'error',
            message: data.data
          });

          if (data.success) {
            form[0].reset();

            if ($('.quick-quote').hasClass('is-active')) {
              $('.quick-quote__close').trigger('click');
            }
          }
        },
        callbackError: (error) => {
          showMessageFeedback({
            type: 'error',
            message: data.data
          })
        }
      })
    });

    $('.services-listing').on('click', '.services-filter__item', function(e) {
      e.preventDefault();
      const button = $(this);
      const url = button.attr('href');

      if (button.hasClass('is-current')) { return false; }

      ajaxContentWrapper({
        url,
        callbackSuccess: (data) => {
          const content = $(data).find('.services-listing').html();
          $('.services-listing').html(content);

          setTimeout(() => {
            $('html, body').stop().animate({
              scrollTop: $('.services-listing').offset().top
            }, 1000);
          }, 300);
        }
      })
    });

    $('.services-listing').on('click', '.load-more a', function(e) {
      e.preventDefault();
      const button = $(this);
      const url = button.attr('href');

      ajaxContentWrapper({
        url,
        callbackSuccess: (data) => {
          const content = $(data).find('.services-listing__grid').html();
          const hasMoreItems = $(data).find('.load-more').length > 0;
          const scrollOffset = $('.services-listing__grid .card-service:last-child').offset().top;

          $('.services-listing__grid').append(content);

          setTimeout(() => {
            $('html, body').stop().animate({
              scrollTop: scrollOffset - 100
            }, 1000);
          }, 300);

          if (!hasMoreItems) {
            button.parent().hide();
          } else {
            button.attr('href', $(data).find('.load-more a').attr('href'));
          }
        }
      })
    });

  });

  $(window).scroll(() => {

  });

  $(window).resize(() => {

  });

})(window, document, jQuery);
